export enum TurnOffAutoPayIHCFlowState {
  INIT = 'init',
  SUCCESS = 'success',
}

export interface TurnOffAutoPayIHCFlowProps {
  onClose: () => void
  onKeepAutoPayEnabled: () => void
  onSuccess: () => void
}
